import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 38,
  height: 42,
}

const shower = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 37.5 41.754'
  >
    <g transform='translate(-0.045)' fill={color}>
      <path d='M36.837,18.4a.708.708,0,0,0,.708-.708V.708A.708.708,0,0,0,36.837,0c-3.062,0-7.783,2.431-7.783,5.66v.708H14.2a3.542,3.542,0,0,0-3.538,3.538v3.372a4.239,4.239,0,0,0-1.354,2.4,9.2,9.2,0,0,0-7.814,8.5A2.117,2.117,0,0,0,2.167,28.3H23.394a2.117,2.117,0,0,0,.678-4.124,9.2,9.2,0,0,0-7.814-8.5,4.239,4.239,0,0,0-1.354-2.4V10.613H29.054v2.123c0,3.229,4.721,5.66,7.783,5.66ZM30.469,5.66c0-2.052,3.263-3.873,5.66-4.2V16.931c-2.4-.322-5.66-2.143-5.66-4.2ZM14.776,15.566h-3.99c.239-.718.778-1.415,1.288-1.415h1.415c.512,0,1.049.7,1.288,1.415Zm8.618,11.321H2.167a.708.708,0,1,1,0-1.415H23.394a.708.708,0,0,1,0,1.415Zm-.739-2.83H2.907a7.794,7.794,0,0,1,7.751-7.076H14.9a7.794,7.794,0,0,1,7.751,7.076ZM14.2,9.2a.708.708,0,0,0-.708.708v2.83H12.073V9.906A2.123,2.123,0,0,1,14.2,7.783H29.054V9.2Zm0,0' />
      <path
        d='M25.458,336.708a.708.708,0,0,0-1.415,0v.708a.708.708,0,1,0,1.415,0Zm0,0'
        transform='translate(-21.876 -306.283)'
      />
      <path
        d='M57.458,336.708a.708.708,0,0,0-1.415,0v4.245a.708.708,0,0,0,1.415,0Zm0,0'
        transform='translate(-51.046 -306.283)'
      />
      <path
        d='M89.458,336.708a.708.708,0,0,0-1.415,0v.708a.708.708,0,1,0,1.415,0Zm0,0'
        transform='translate(-80.215 -306.283)'
      />
      <path
        d='M121.458,336.708a.708.708,0,0,0-1.415,0v4.245a.708.708,0,0,0,1.415,0Zm0,0'
        transform='translate(-109.385 -306.283)'
      />
      <path
        d='M153.458,336.708a.708.708,0,0,0-1.415,0v.708a.708.708,0,1,0,1.415,0Zm0,0'
        transform='translate(-138.555 -306.283)'
      />
      <path
        d='M185.458,336.708a.708.708,0,0,0-1.415,0v4.245a.708.708,0,0,0,1.415,0Zm0,0'
        transform='translate(-167.725 -306.283)'
      />
      <path
        d='M217.458,336.708a.708.708,0,0,0-1.415,0v.708a.708.708,0,1,0,1.415,0Zm0,0'
        transform='translate(-196.894 -306.283)'
      />
      <path
        d='M56.751,416a.708.708,0,0,0-.708.708v2.123a.708.708,0,1,0,1.415,0v-2.123A.708.708,0,0,0,56.751,416Zm0,0'
        transform='translate(-51.046 -379.207)'
      />
      <path
        d='M120.751,416a.708.708,0,0,0-.708.708v2.123a.708.708,0,1,0,1.415,0v-2.123A.708.708,0,0,0,120.751,416Zm0,0'
        transform='translate(-109.385 -379.207)'
      />
      <path
        d='M184.751,416a.708.708,0,0,0-.708.708v2.123a.708.708,0,1,0,1.415,0v-2.123A.708.708,0,0,0,184.751,416Zm0,0'
        transform='translate(-167.725 -379.207)'
      />
      <path
        d='M248.751,416a.708.708,0,0,0-.708.708v2.123a.708.708,0,1,0,1.415,0v-2.123A.708.708,0,0,0,248.751,416Zm0,0'
        transform='translate(-226.064 -379.207)'
      />
      <path
        d='M249.458,336.708a.708.708,0,0,0-1.415,0v4.245a.708.708,0,0,0,1.415,0Zm0,0'
        transform='translate(-226.064 -306.283)'
      />
      <path
        d='M25.458,376.708a.708.708,0,0,0-1.415,0v4.245a.708.708,0,0,0,1.415,0Zm0,0'
        transform='translate(-21.876 -342.745)'
      />
      <path
        d='M89.458,376.708a.708.708,0,0,0-1.415,0v4.245a.708.708,0,0,0,1.415,0Zm0,0'
        transform='translate(-80.215 -342.745)'
      />
      <path
        d='M153.458,376.708a.708.708,0,0,0-1.415,0v4.245a.708.708,0,0,0,1.415,0Zm0,0'
        transform='translate(-138.555 -342.745)'
      />
      <path
        d='M217.458,376.708a.708.708,0,0,0-1.415,0v4.245a.708.708,0,0,0,1.415,0Zm0,0'
        transform='translate(-196.894 -342.745)'
      />
      <path
        d='M25.017,456.043a.733.733,0,0,0-.41-.035.949.949,0,0,0-.127.035,1.389,1.389,0,0,0-.128.071,1.179,1.179,0,0,0-.105.085.816.816,0,0,0-.149.234.594.594,0,0,0-.057.269.708.708,0,1,0,1.358-.269.731.731,0,0,0-.149-.234,1.073,1.073,0,0,0-.234-.156Zm0,0'
        transform='translate(-21.874 -415.664)'
      />
      <path
        d='M88.248,456.3a.731.731,0,0,0-.149.234.7.7,0,0,0,.149.771.73.73,0,0,0,.234.149.7.7,0,0,0,.92-.92.815.815,0,0,0-.149-.234A.741.741,0,0,0,88.248,456.3Zm0,0'
        transform='translate(-80.215 -415.76)'
      />
      <path
        d='M153.139,456.124a.762.762,0,0,0-.12-.071.821.821,0,0,0-.135-.035.712.712,0,0,0-.4.035,1.065,1.065,0,0,0-.234.156.73.73,0,0,0-.149.234.7.7,0,0,0,.149.771.815.815,0,0,0,.234.149.7.7,0,0,0,.92-.92.815.815,0,0,0-.149-.234A.72.72,0,0,0,153.139,456.124Zm0,0'
        transform='translate(-138.554 -415.673)'
      />
      <path
        d='M216.246,456.3a.73.73,0,0,0-.149.234.592.592,0,0,0-.057.269.7.7,0,0,0,.205.5.815.815,0,0,0,.234.149.7.7,0,0,0,.976-.651.6.6,0,0,0-.057-.269.816.816,0,0,0-.149-.234A.741.741,0,0,0,216.246,456.3Zm0,0'
        transform='translate(-196.892 -415.76)'
      />
    </g>
  </svg>
)

export default shower
